import Fetcher from '../../common/util/Fetcher';
import { handleItemAnalysesResponse } from '../../common/api/callHandlers';
import { associateItemAnalyses } from '../../common/actions/quizzes';
import withDynamoPagination from '../../common/util/withDynamoPagination';
export function getItemAnalyses(quizId) {
  var url = "/api/quizzes/".concat(quizId, "/stats/item_analyses/");
  return function (dispatch, getState) {
    var DynamoFetcher = withDynamoPagination(Fetcher);
    var dynamoFetcherGet = new DynamoFetcher();
    return dynamoFetcherGet.paginatedGet(url).then(function (response) {
      dispatch([handleItemAnalysesResponse(response), associateItemAnalyses(quizId, response)]);
    });
  };
}